/* Pixiwoo — Frog Hub collection page (templates/collection.frog-hub.json): rail arrows. No dependencies. */
(() => {
  // Every pxw-fh-* section emits this script tag so it also works standalone in the
  // Theme editor. The browser fetches the file once but runs each tag, so bail out
  // after the first run.
  if (window.__pxwFhInit) return;
  window.__pxwFhInit = true;

  const reducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(root) {
    if (root.dataset.pxwFhReady) return;
    root.dataset.pxwFhReady = '1';

    const track = root.querySelector('[data-pxw-fh-rail-track]');
    const prev = root.querySelector('[data-pxw-fh-rail-prev]');
    const next = root.querySelector('[data-pxw-fh-rail-next]');
    if (!track) return;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const go = (dir) => {
      track.scrollBy({
        left: dir * Math.round(track.clientWidth * 0.8),
        behavior: reducedMotion() ? 'auto' : 'smooth',
      });
    };

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-pxw-fh-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
